import { connect } from 'react-redux';

import { CHECKOUT_URL } from 'Route/Checkout/Checkout.config';
import {
    mapDispatchToProps,
    mapStateToProps,
    MyAccountSignInContainer as SourceMyAccountSignInContainer
} from 'SourceComponent/MyAccountSignIn/MyAccountSignIn.container';
import componentLoader from 'Util/componentLoader';
import transformToNameValuePair from 'Util/Form/Transform';
import browserHistory from 'Util/History';
import { getErrorMessage } from 'Util/Request';

export const MyAccountDispatcher = componentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/MyAccount/MyAccount.dispatcher'
), 2);
export {
    mapStateToProps,
    mapDispatchToProps
};

/** @namespace Bodypwa/Component/MyAccountSignIn/Container */
export class MyAccountSignInContainer extends SourceMyAccountSignInContainer {
    async onSignInSuccess(form, fields) {
        const {
            signIn,
            showNotification,
            onSignIn,
            setLoadingState
        } = this.props;

        const {
            location: {
                pathname
            }
        } = browserHistory;
        const isCheckout = pathname.includes(CHECKOUT_URL);

        setLoadingState(true);
        const fieldPairs = transformToNameValuePair(fields);

        try {
            await signIn(fieldPairs);
            if (!isCheckout) {
                onSignIn();
                browserHistory.push('/my-account');
            }
        } catch (error) {
            showNotification('error', getErrorMessage(error));
        }

        setLoadingState(false);
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountSignInContainer);
